import { action } from '../../action';
export const TableActionType = {
  SelectRow: 'row/selectRow',
  SelectRows: 'row/selectRows',
  PartiallySelectedRows: 'row/partiallySelectedRows',
  SelectAll: 'row/selectAll',
  FocusCell: 'cell/focus',
  ActiveCell: 'cell/active',
  PressedCell: 'cell/pressed',
  ScrollPosition: 'table/scrollPosition',
  ClearMeasurementCache: 'table/clearMeasurementCache',
  FocusIndicator: 'cell/focusIndicator',
  FrozenColumn: 'table/frozenColumnCount',
  ResizeColumn: 'column/resizeColumn',
  ClearResizedColumns: 'column/clearResizedColumns',
  FreezeColumn: 'table/freezeColumn',
  OrderedColumnKeys: 'table/orderedColumnKeys'
};
export const actions = {
  TableActionType,
  createSelectRow(payload) {
    return action(TableActionType.SelectRow, payload);
  },
  createSelectedRows(payload) {
    return action(TableActionType.SelectRows, payload);
  },
  createSelectAll(payload) {
    return action(TableActionType.SelectAll, payload);
  },
  createActiveCell(payload) {
    return action(TableActionType.ActiveCell, payload);
  },
  createPartiallySelectedRows(payload) {
    return action(TableActionType.PartiallySelectedRows, payload);
  },
  createPressedCell(payload) {
    return action(TableActionType.PressedCell, payload);
  },
  createFocus(payload) {
    return action(TableActionType.FocusCell, payload);
  },
  createScrollPosition(payload) {
    return action(TableActionType.ScrollPosition, payload);
  },
  createFocusIndicator(payload) {
    return action(TableActionType.FocusIndicator, payload);
  },
  createFrozenColumnCount(payload) {
    return action(TableActionType.FrozenColumn, payload);
  },
  createResizeColumn(payload) {
    return action(TableActionType.ResizeColumn, payload);
  },
  createClearResizedColumns() {
    return action(TableActionType.ClearResizedColumns);
  },
  createFreezeColumn(payload) {
    return action(TableActionType.FreezeColumn, payload);
  },
  createOrderedColumnKeys(payload) {
    return action(TableActionType.OrderedColumnKeys, payload);
  },
  createClearMeasurementCache(payload) {
    return action(TableActionType.ClearMeasurementCache, payload);
  }
};
//# sourceMappingURL=TableAction.js.map